/**
 * Bulk upload column labels & sequence aligned with RFID report/table headers.
 * (Same names/order as RFID_EXPORT_COLUMNS, excluding auto-generated fields.)
 */
export const RFID_BULK_UPLOAD_COLUMNS = [
  {
    key: "rfidType",
    keys: ["rfidType", "assetType", "rfidTypeName", "assetTypeName"],
    label: "Asset Type",
  },
  {
    key: "assetCategory",
    keys: ["assetCategory", "rfidCategory", "assetCategoryName", "rfidCategoryName"],
    label: "Asset Category",
  },
  {
    key: "imeiNo",
    keys: ["imeiNo", "imeiSlMfgNo", "imei"],
    label: "IMEI/SL/MFG",
  },
  {
    key: "zone",
    keys: ["zone", "zoneName"],
    label: "Zone",
  },
  {
    key: "ward",
    keys: ["ward", "wardNo", "wardName", "circleName"],
    label: "Ward",
  },
  {
    key: "location",
    keys: ["location", "locationLandmark", "locationName"],
    label: "Location/Landmark",
  },
  {
    key: "assetArea",
    keys: ["assetArea", "installedArea", "assetAreaType"],
    label: "Installed Area",
  },
  {
    key: "otherNo",
    keys: ["otherNo", "vehicleNo"],
    label: "Other No",
  },
  {
    key: "collectionType",
    keys: ["collectionType", "collectionTypeName"],
    label: "Collection Type",
  },
  {
    key: "vehicleType",
    keys: ["vehicleType", "vehicleTypeName"],
    label: "Vehicle Type",
  },
  {
    key: "vehicleCapacity",
    keys: ["vehicleCapacity", "vehicleCapacityName"],
    label: "Vehicle Capacity",
  },
  {
    key: "ownerType",
    keys: ["ownerType", "ownerTypeName"],
    label: "Owner Type",
  },
  {
    key: "dateOfInstallation",
    keys: ["dateOfInstallation", "installDate", "installationDate"],
    label: "Date Of Installation",
  },
  {
    key: "warrantyExpireDate",
    keys: [
      "warrantyExpireDate",
      "warrantyExpDate",
      "warrantyExpired",
      "warrantyEXPDate",
    ],
    label: "Warranty Expire Date",
  },
  {
    key: "purchaseDate",
    keys: ["purchaseDate", "dateOfPurchase"],
    label: "Purchase Date",
  },
  {
    key: "insuranceNo",
    keys: ["insuranceNo"],
    label: "Insurance No",
  },
  {
    key: "insuranceValidity",
    keys: ["insuranceValidity"],
    label: "Insurance Validity",
  },
  {
    key: "insuranceProvider",
    keys: ["insuranceProvider"],
    label: "Insurance Provider",
  },
  {
    key: "status",
    keys: ["status", "isActive"],
    label: "Status",
  },
];

export const RFID_BULK_UPLOAD_HEADER_LABELS = RFID_BULK_UPLOAD_COLUMNS.map(
  (col) => col.label
);

export const getRfidBulkFieldValue = (row, column) => {
  const keys = column.keys || [column.key];
  for (const key of keys) {
    const value = row?.[key];
    if (value !== null && value !== undefined && value !== "") {
      return String(value);
    }
  }
  return "-";
};
